import { Brands, getTranslationProps } from '@webc/meeseeks-ui-sdk';
import { languagesSelector, mainBrandUUIDSelector } from 'app/store/selectors';
import { useAppSelector } from 'app/hooks/appHooks';

export const useTranslations = (
  keys: Record<string, string> | ((x: any) => []),
  getAllTranslations?: boolean,
): ReturnType<typeof getTranslationProps> => {
  const strings = useAppSelector(languagesSelector);
  const brand = useAppSelector(mainBrandUUIDSelector);

  return getTranslationProps(strings, {}, !!getAllTranslations, keys, brand as Brands);
};
